<div class="service-def-card" [class.active]="active" [class.completed]="completed">
  <div class="status-row">
    @if (completed) {
      <mat-icon svgIcon="circle_tick" class="status-icon completed-icon"></mat-icon>
    }
    @if (active && !completed) {
      <mat-icon svgIcon="circle_dot" class="status-icon active-icon"></mat-icon>
    }
    @if (!active && !completed) {
      <mat-icon svgIcon="circle_dot" class="status-icon inactive-icon"></mat-icon>
    }
    <span [class.text-disabled]="!active && !completed" class="status-text fs-16 fw-500">{{ 'TENANT_LAYOUT.SERVICE_DEFINITION.SERVICE_DEFINITION_VERSION' | transloco }}</span>
  </div>
  @if (version) {
    <div class="version-row">
      <span class="version-text fs-12 fw-400">{{'BLUEPRINT_SUMMARY.VERSION_NOTE' | transloco}} {{ version }}</span>
    </div>
  }
</div>
